import { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import { get } from "../../../api";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";

export default function useCourtPasses() {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [availablePasses, setAvailablePasses] = useState<Ticket[]>([]);

  const getAvailablePasses = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setAvailablePasses(result);
    }
    setLoading(false);
  };

  // Filtrowanie karnetów dostępnych do zapisywania (nie bilety)
  const getFilteredPasses = (exerciseStartTime: number) => {
    return availablePasses.filter(
      (item) =>
        item.ticket === false && // nie jest biletem
        item.validfrom <= exerciseStartTime && // karnet jest już ważny
        exerciseStartTime <= item.validto && // karnet jeszcze nie wygasł
        item.entrances - item.exercises.length > 0 // ma pozostałe wejścia
    );
  };

  useEffect(() => {
    if (facilityIds) {
      getAvailablePasses();
    }
    //eslint-disable-next-line
  }, [facilityIds]);

  return {
    loading,
    availablePasses,
    getFilteredPasses,
    refetchPasses: getAvailablePasses,
  };
}
